import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Platform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AccountService } from "src/service/account.service";
import { AlertService } from "src/service/alert.service";
import { AuthenticationService } from "src/service/authentication.service";
import { EventService } from "src/service/event.service";
import { LoaderService } from "src/service/loader.service";
import { LoggerService } from "src/service/logger.service";
import { SystemRouterService } from "src/service/system-router.service";

@Component({
    selector: "app-form-request-change-pwd",
    templateUrl: "./form-request-change-pwd.component.html",
    styleUrls: ["./form-request-change-pwd.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormRequestChangePwdComponent implements OnInit {
  private _logContext: string = "form-request-change-pwd.component";
  private _formSubscriptions: Array<Subscription> = null;
  private _translateSubscription: Subscription = null;
  private _errorUnAuthorizeSubscription: Subscription = null;
  private _keyboardSubscriptions: Subscription = null;

  //#region Translate variable
  //#endregion

  public formRequestPWD: UntypedFormGroup = null;
  public passwordInputType: string = "password";
  public passwordIconType: string = "eye";
  public forcedActive: boolean = false;

  @Output() onChangePasswordSuccess: EventEmitter<any> = new EventEmitter();

  constructor(
    private _platform: Platform,
    private _fb: UntypedFormBuilder,
    private _alertService: AlertService,
    private _authService: AuthenticationService,
    private _loaderService: LoaderService,
    private _eventService: EventService,
    private _loggerService: LoggerService,
    private _translateService: TranslateService,
    private _routerService: SystemRouterService,
    private _accountService: AccountService,
  ) {}

  ngOnInit() {
    this.forcedActive = false;

    this.loadTranslation();
    this.subscribeTranslationEvent();

    this.initializeForm();
    this.subscribeFormEvent();
  }

  ngOnDestroy() {
    this.unsubscribeFormEvent();

    this._translateSubscription?.unsubscribe();
    this._errorUnAuthorizeSubscription?.unsubscribe();
    this._keyboardSubscriptions?.unsubscribe();
  }

  //#region Translation
  public loadTranslation(): void {
    /*this._translateService
      .get([
        "",
      ])
      .subscribe((translation) => {});*/
  }

  public subscribeTranslationEvent(): void {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      },
    );
  }
  //#endregion

  /**
   * Initialize login form plant
   */
  private initializeForm(): void {
    this.formRequestPWD = this._fb.group({
      Email: new UntypedFormControl("", {
        validators: Validators.compose([Validators.email, Validators.required]),
      }),
    });
  }

  /**
   * Subscribe value change event from each form field.
   */
  private subscribeFormEvent(): void {
    this._formSubscriptions = new Array<Subscription>();
  }

  /**
   * Unsubscribe to form event events
   */
  private unsubscribeFormEvent(): void {
    for (const sub of this._formSubscriptions) {
      sub.unsubscribe();
    }
  }

  /**
   * Enter pressed in the field: same as the confirm button, when the email is valid
   */
  public onSubmitForm(): void {
    if (this.formRequestPWD.valid) {
      this.onClickRequestPwd();
    }
  }

  public onClickRequestPwd() {
    if (this.formRequestPWD.valid) {
      this.onChangePasswordSuccess.emit(this.formRequestPWD.get("Email").value);
    } else {
      this.formRequestPWD.get("Email").markAsTouched();
    }
  }

  /**
   * Return to login page
   */
  public onClickGoBack() {
    this._routerService.navigateToDigitalPlaceLogin();
  }
}
